import { useCallback, useState } from "react";
import { UseMenuOptions } from "./useMenu";

export type UseMenuOpenStateResult = Pick<UseMenuOptions, "isOpen" | "onOpenRequested" | "onCloseRequested">;

/**
 * Common helpers to play along with `useMenu`.
 */
export const useMenuOpenState = (): UseMenuOpenStateResult => {
    const [isOpen, setIsOpen] = useState(false);

    const onOpenRequested = useCallback(() => setIsOpen(true), []);
    const onCloseRequested = useCallback(() => setIsOpen(false), []);

    return {
        isOpen,
        onOpenRequested,
        onCloseRequested,
    };
};
